/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OrganizationClientLegalEntityVerificationRequestStatusResource } from './';
import {
    OrganizationClientLegalEntityVerificationRequestStatusResourceFromJSON,
    OrganizationClientLegalEntityVerificationRequestStatusResourceFromJSONTyped,
    OrganizationClientLegalEntityVerificationRequestStatusResourceToJSON,
} from './';
import type { OrganizationVerificationStatus } from './';
import {
    OrganizationVerificationStatusFromJSON,
    OrganizationVerificationStatusFromJSONTyped,
    OrganizationVerificationStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationClientLegalEntitiesVerificationRequestStatusResource
 */
export interface OrganizationClientLegalEntitiesVerificationRequestStatusResource {
    /**
     * 
     * @type {OrganizationVerificationStatus}
     * @memberof OrganizationClientLegalEntitiesVerificationRequestStatusResource
     */
    status: OrganizationVerificationStatus;
    /**
     * 
     * @type {number}
     * @memberof OrganizationClientLegalEntitiesVerificationRequestStatusResource
     */
    notVerifiedLegalEntitiesCount: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationClientLegalEntitiesVerificationRequestStatusResource
     */
    singleNotVerifiedLegalEntityId?: string;
    /**
     * The first legal entities eligible for a manual verification request, capped at the requested maxRequestableLegalEntities (default 5).
     * @type {Array<OrganizationClientLegalEntityVerificationRequestStatusResource>}
     * @memberof OrganizationClientLegalEntitiesVerificationRequestStatusResource
     */
    requestableLegalEntities: Array<OrganizationClientLegalEntityVerificationRequestStatusResource>;
    /**
     * The total number of legal entities eligible for a manual verification request.
     * @type {number}
     * @memberof OrganizationClientLegalEntitiesVerificationRequestStatusResource
     */
    requestableLegalEntitiesCount: number;
}

/**
 * Check if a given object implements the OrganizationClientLegalEntitiesVerificationRequestStatusResource interface.
 */
export function instanceOfOrganizationClientLegalEntitiesVerificationRequestStatusResource(value: object): value is OrganizationClientLegalEntitiesVerificationRequestStatusResource {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('notVerifiedLegalEntitiesCount' in value) || value['notVerifiedLegalEntitiesCount'] === undefined) return false;
    if (!('requestableLegalEntities' in value) || value['requestableLegalEntities'] === undefined) return false;
    if (!('requestableLegalEntitiesCount' in value) || value['requestableLegalEntitiesCount'] === undefined) return false;
    return true;
}

export function OrganizationClientLegalEntitiesVerificationRequestStatusResourceFromJSON(json: any): OrganizationClientLegalEntitiesVerificationRequestStatusResource {
    return OrganizationClientLegalEntitiesVerificationRequestStatusResourceFromJSONTyped(json, false);
}

export function OrganizationClientLegalEntitiesVerificationRequestStatusResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationClientLegalEntitiesVerificationRequestStatusResource {
    if (json == null) {
        return json;
    }
    return {
        
        'status': OrganizationVerificationStatusFromJSON(json['status']),
        'notVerifiedLegalEntitiesCount': json['notVerifiedLegalEntitiesCount'],
        'singleNotVerifiedLegalEntityId': json['singleNotVerifiedLegalEntityId'] == null ? undefined : json['singleNotVerifiedLegalEntityId'],
        'requestableLegalEntities': ((json['requestableLegalEntities'] as Array<any>).map(OrganizationClientLegalEntityVerificationRequestStatusResourceFromJSON)),
        'requestableLegalEntitiesCount': json['requestableLegalEntitiesCount'],
    };
}

export function OrganizationClientLegalEntitiesVerificationRequestStatusResourceToJSON(value?: OrganizationClientLegalEntitiesVerificationRequestStatusResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': OrganizationVerificationStatusToJSON(value['status']),
        'notVerifiedLegalEntitiesCount': value['notVerifiedLegalEntitiesCount'],
        'singleNotVerifiedLegalEntityId': value['singleNotVerifiedLegalEntityId'],
        'requestableLegalEntities': ((value['requestableLegalEntities'] as Array<any>).map((v) => OrganizationClientLegalEntityVerificationRequestStatusResourceToJSON(v))),
        'requestableLegalEntitiesCount': value['requestableLegalEntitiesCount'],
    };
}

